<div style="width: 500px; display: flex; flex-flow: row; justify-content: space-between; align-items: baseline; margin-bottom: 10px">
  <div style="width: 100px">
    <mat-form-field>
      <mat-label>Näytä kielellä</mat-label>
      <mat-select placeholder="Kieli" [formField]="kieliValinta" (selectionChange)="valittuKieliSignal.set($event.value)" style="width: 100%">
        <mat-option value="fi">Suomi</mat-option>
        <mat-option value="en">Englanti</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div style="width: 200px">
    <mat-form-field>
      <mat-label>Profiili</mat-label>
      <mat-select [(value)]="valittuProfiiliAvainSignal">
        <mat-option [value]="null"> Ei profiilia </mat-option>
        @for (profiili of profiilitSignal(); track profiili) {
          <mat-option [value]="profiili.avain">
            {{ profiili.nimi }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (valittuProfiiliPuuttuuSignal(); as errorText) {
      <div class="error-text">{{ errorText }}</div>
    }
  </div>
</div>
@if (commonErrorSignal(); as errorText) {
  <div class="error-text">{{ errorText }}</div>
}

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<div class="example-list" [class.hidden]="loading">
  @for (node of flatatytSignal(); track node) {
    <div (click)="muokkaa(node.kirjanpitotili, node.profiilinOsa)" class="example-box" [style.padding-left]="node.level * 15 + 'px'">
      {{ node.name }}
      @if (node.profiilissaMuutetutTiedot) {
        <span style="color: gray">{{ node.profiilissaMuutetutTiedot }}</span>
      }
    </div>
  }
</div>
